module.exports = __webpack_public_path__ + "images/category_lp/construction_equipment/assessment_achievements/6@2x_76f76f8bf329861ed3fa1af5da9efe06.png";